import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination
} from '@material-ui/core';
import SearchNotFound from '../../SearchNotFound';
import Scrollbar from '../../Scrollbar';
import { UserListHead, UserListToolbar } from '../../user';
import RemoveGlobalAdminButton from './RemoveGlobalAdminButton';
import { applySortFilter, getComparator } from '../../../utils/sort';

const TABLE_HEAD = [
  { id: 'username', label: 'Email', alignRight: false },
  { id: '', label: '', alignRight: true }
];

GlobalAdminTable.propTypes = {
  admins: PropTypes.array.isRequired,
  updateAdmins: PropTypes.func.isRequired
};

export default function GlobalAdminTable({ admins, updateAdmins }) {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('username');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };

  const filteredAdmins = applySortFilter(admins, getComparator(order), filterName, undefined);
  const isNotFound = filteredAdmins.length === 0;

  const tableContent = (
    <>
      <UserListToolbar
        placeholder="Search admins..."
        filterName={filterName}
        onFilterName={handleFilterByName}
      />
      <TableContainer data-testid="global-admin-table">
        <Table>
          <UserListHead
            order={order}
            orderBy={orderBy}
            headLabel={TABLE_HEAD}
            rowCount={admins.length}
            onRequestSort={handleRequestSort}
          />
          <TableBody>
            {filteredAdmins != null &&
              filteredAdmins
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((username) => (
                  <TableRow hover key={username} tabIndex={-1}>
                    <TableCell align="left" sx={{ py: 3 }}>
                      {username}
                    </TableCell>
                    <TableCell align="right" sx={{ py: 3 }}>
                      <RemoveGlobalAdminButton username={username} onRemoved={updateAdmins} />
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
          {isNotFound && (
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={2} sx={{ py: 3 }}>
                  <SearchNotFound searchQuery={filterName} />
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredAdmins.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );

  return (
    <Card>
      <Scrollbar>{tableContent}</Scrollbar>
    </Card>
  );
}
